
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 40 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 50.492L4.057 0l35.615 2.254-4.959 50.492L0 50.492z","fill":"#FE5E4A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.262 19.836a.5.5 0 01.5-.5h7.664a.5.5 0 01.496.566l-.902 6.762a.5.5 0 01-.529.433l-6.762-.45a.5.5 0 01-.467-.5v-6.31zm1 .5v5.344l5.829.388.764-5.732H7.262zm9.98-.415a.5.5 0 01.375-.133l6.312.451a.5.5 0 01.464.499V27.5a.5.5 0 01-.5.5h-6.311a.5.5 0 01-.5-.5v-7.213a.5.5 0 01.16-.366zm.84.903V27h5.311v-5.797l-5.311-.38zm9.076-.451a.5.5 0 01.375-.134l6.762.45a.5.5 0 01.466.53l-.45 7.214a.5.5 0 01-.5.469H27.5a.5.5 0 01-.5-.5v-7.664a.5.5 0 01.158-.365zm.842.9v6.629h5.342l.39-6.248L28 21.272zM5.36 29.753a.5.5 0 01.5-.5h7.665a.5.5 0 01.499.528l-.451 8.115a.5.5 0 01-.591.463l-7.214-1.352a.5.5 0 01-.407-.492v-6.762zm1 .5v5.847l6.246 1.171.39-7.018H6.36zm10.271.853a.5.5 0 01.5-.5h6.762a.5.5 0 01.5.5v7.213a.5.5 0 01-.533.499l-6.762-.451a.5.5 0 01-.467-.5v-6.761zm1 .5V37.4l5.762.384v-6.178h-5.762zm9.554-.438a.5.5 0 01.39-.106l5.862.902a.5.5 0 01.422.537L32.506 48.28a.5.5 0 01-.54.456l-5.41-.45a.5.5 0 01-.457-.527l.902-16.23a.5.5 0 01.184-.36zm.784.966l-.844 15.194 4.428.369 1.27-14.816-4.854-.747zM5.36 40.574a.5.5 0 01.5-.5h6.762a.5.5 0 01.5.5v6.762a.5.5 0 01-.5.5H5.86a.5.5 0 01-.5-.5v-6.762zm1 .5v5.762h5.762v-5.762H6.36zm9.82-.5a.5.5 0 01.5-.5h6.761a.5.5 0 01.5.5v7.664a.5.5 0 01-.566.495l-6.762-.901a.5.5 0 01-.434-.496v-6.762zm1 .5v5.824l5.761.769v-6.593H17.18z","fill":"#001C45"}}),_c('path',{attrs:{"d":"M7.664 14.426l.902-9.467 25.606 2.098-1.262 9.172-25.246-1.803z","fill":"#fff"}})])
          )
        }
      }
    